import { z } from 'zod';

export const healthSchema = z.object({
  message: z.string(),
  statusCode: z.number()
});

export type HealthType = z.infer<typeof healthSchema>;
